import { Component, Output, EventEmitter, Input, ViewChild, ViewContainerRef, ComponentRef, ComponentFactoryResolver, ChangeDetectorRef, isDevMode, ElementRef, inject } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { FastModeService } from '../../../../../services/fast-mode.service';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { FruHttpService } from '../../../../../services/fru-http.service';
import { JornayaService } from '../../../../../services/jornaya.service';
import { AnalyticsService } from '../../../../../services/analytics.service';
import { CommunicationService } from '../../../../../services/communication.service';
import { RandomService } from '../../../../../services/random.service';
import { BrandService } from '../../../../../services/brand.service';
import { SvgFixService } from '../../../../../services/svg-fix.service';

@Component({
    selector: 'app-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
    standalone: false
})

export class StepComponent {

  /** FAST mode (FRU-21170): used by the host to pause the walk at non-fillable steps. */
  protected fastModeHost = inject(FastModeService);

  @ViewChild('target', { read: ViewContainerRef }) target;
  @Output() stepEvent = new EventEmitter<string>();
  @Input() type;
  @Input() isSelectedLeads;
  @Input() selectedLenders;
  @Input() isBeEnabled;
  @Input() isUncheckedTest;

  cmpRef: ComponentRef<any>;
  state: string = 'inactive';
  private isViewInitialized: boolean = false;
  form: UntypedFormGroup;
  inputModeTest:boolean = false;
  highlightingBoxForRequiredInfo:boolean;
  private _isTopTenBestLenders = new BehaviorSubject<boolean>(false);
  isTopTenBestLenders: boolean = false;
  isTopTenBestLenders$ = this._isTopTenBestLenders.asObservable();
  isFullFastFlow: boolean = false;
  

  lenders: BehaviorSubject<Array<Object>> = new BehaviorSubject([]);
  selectedType: BehaviorSubject<string> = new BehaviorSubject('fru');
  isTop10MoreLenders: boolean = false;
  branded: any;
  isShowLenders: boolean;
  isSelectedRun: boolean = false;
  isUncheckedValidation: boolean = false;
  isBeNote: boolean = false;
  top10FormDesign2025: boolean = false;

  constructor(
    protected parent: FormGroupDirective,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdRef: ChangeDetectorRef,
    protected elementRef: ElementRef,
    protected fruHttpService: FruHttpService,
    protected jornayaService: JornayaService,
    protected analyticsService: AnalyticsService,
    protected communication: CommunicationService,
    protected randomService: RandomService,
    protected brandService: BrandService,
    protected svgFixService: SvgFixService
  ) {
    this.form = this.parent.form;

    if (this.brandService.domain.includes('top10bestlenders')) {
      this.top10FormDesign2025 = true;
    }

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        this.highlightingBoxForRequiredInfo = variationData.enabledVariations.hasOwnProperty('HighlightingBoxForRequiredInfo');
        
        this.isFullFastFlow = new URLSearchParams(window.location.search).get('fast_variant') === 'yes';

        if (variationData.enabledVariations.hasOwnProperty('NewQuestions')) {
          this.isTopTenBestLenders = true;
          this._isTopTenBestLenders.next(true);
        }
      }
    );
  }

  public enterPress() {
    this.cmpRef.instance.submit();
  }

  updateComponent() {
    if (!this.isViewInitialized) {
      return;
    }
    if (this.cmpRef) {
      console.log('Destroy Run');
      Sentry.captureMessage('Destroy Run');
      this.cmpRef.destroy();
    }

    if (typeof this.type !== 'undefined') {

      let factory = this.componentFactoryResolver.resolveComponentFactory(this.type);
      this.cmpRef = this.target.createComponent(factory);

      this.cmpRef.instance.stepEvent.subscribe(val => {
        this.nextStep();
      });

      this.cdRef.detectChanges();
    }
    this.svgFixService.fixSvgUse();
  }

  detectChanges() {
    this.cdRef.detectChanges();
  }

  ngOnChanges() {

    if (this.isBeEnabled == false) {
      if (this.cmpRef) {
        this.cmpRef.instance.isBeNote = true;
      }
    } else {
      // Allow update component
      this.updateComponent();
    }

    // if (this.isSelectedLeads) {
    //   if (this.cmpRef) {
    //     if (this.isUncheckedTest) {
    //       this.cmpRef.instance.isUncheckedValidation = true;
    //     }
    //     this.cmpRef.instance.isSelectedRun = true;
    //     if (this.selectedLenders.lead_id) {
    //       this.cmpRef.instance.lenders.next(this.selectedLenders?.lenders);
    //       this.cmpRef.instance.selectedType.next(this.selectedLenders?.type);
    //       if (this.selectedLenders?.lenders.length) {
    //         this.cmpRef.instance.isShowLenders = true;
    //       }
    //       if (this.selectedLenders?.lenders.length > 1) {
    //         this.cmpRef.instance.isTop10MoreLenders = true;
    //         this.cmpRef.instance.branded = this.selectedLenders?.lenders[0];
    //       }
    //     }
    //   }
    // } else {
    //   // Allow update component
    //   this.updateComponent();
    // }
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
    this.updateComponent();
  }

  ngDestroy() {
    if (this.cmpRef) {
      Sentry.captureMessage('ngDestroy Run');
      this.cmpRef.destroy();
    }
  }

  /** FRU-24835: the reverse mortgage flow (the rates form adds flowType 'reverse' only there). */
  get isReverseFlow(): boolean {
    return this.form?.controls?.['flowType']?.value === 'reverse';
  }

  nextStep() {
    // ToDo: Why this method is called twice after each step???

    this.toggleState();
    this.stepEvent.emit('next');
  }

  toggleState() {
    this.state = this.state === 'active' ? 'inactive' : 'active';
  }

  /**
   * Use this function in child if there's something we need to check requiring us to redirect to the offers page
   */
  shouldRedirectToOffers(value: string): boolean {
    return false;
  }

  shouldRedirectToPLOffers(value: string): boolean {
    return value === 'Rent';
  }

  /**
   * Use this function in child if there's something we need to check requiring us to redirect to rate tables page
   */
  redirectTables(value: string): boolean {
    return false;
  }

  /**
   * use this function in child if there's something needed done when the question becomes visible
   */
  initStep() {
    if (typeof this.cmpRef !== 'undefined' && typeof this.cmpRef.instance.submit === 'function') {
      this.cmpRef.instance.initStep();
      // FAST mode (FRU-21170): run the auto-advance AFTER the leaf's own initStep,
      // so steps that override initStep (e.g. maximumEquity) don't shadow it.
      try {
        if (this.cmpRef && this.cmpRef.instance && typeof this.cmpRef.instance.fastTry === 'function') {
          this.cmpRef.instance.fastTry();
        } else if (this.fastModeHost && this.fastModeHost.canAutoAdvance) {
          // Reached a step FAST can't auto-fill (zip / contact) -> pause for the user.
          this.fastModeHost.pauseForUser();
        }
      } catch (e) { }
    }
  }

  setDesiredLoanAmount() {
    let amount: number = 0;

    switch (this.form.controls.type.value) {
      case 'purchase':
        let purchasePrice = isNaN(parseInt(this.form.controls.newHomeValue.value)) ? 0 : parseInt(this.form.controls.newHomeValue.value);
        let downPayment = isNaN(parseFloat(this.form.controls.estimatedDownPayment.value)) ? 0 : (parseFloat(this.form.controls.estimatedDownPayment.value) / 100) * purchasePrice;
        amount = purchasePrice - downPayment;
        break;
      default:
        let mortgageBalance: number = isNaN(parseInt(this.form.controls.firstMortgageBalance.value)) ? 0 : parseInt(this.form.controls.firstMortgageBalance.value);
        let cashOut: number = isNaN(parseInt(this.form.controls.cashOut.value)) ? 0 : parseInt(this.form.controls.cashOut.value);
        amount = mortgageBalance + cashOut;
        break;
    }

    this.form.controls.desiredLoanAmount.setValue(amount);

    if (isDevMode()) {
      console.log('Set desiredLoanAmount', amount);
    }
  }

  setLTV() {
    let ltv:number = 0;

    if (this.form.controls.type.value === 'purchase') {
      let downPaymentPercent = parseFloat(this.form.controls.estimatedDownPayment.value);
      ltv = (isNaN(downPaymentPercent)) ? 0 : 100 - downPaymentPercent;
    } else {
      let propertyValue = parseInt(this.form.controls.propertyValue.value);
      let mortgageBalance = parseInt(this.form.controls.firstMortgageBalance.value);

      if (!isNaN(propertyValue) && propertyValue > 0 && !isNaN(mortgageBalance)) {
        ltv = (mortgageBalance * 100) / propertyValue;
      }
    }

    if (isDevMode()) {
      console.log('Set ltv', ltv);
    }

    this.form.controls.ltv.setValue(ltv);
  }

  snap() {
    this.jornayaService.snap();
  }
}
